import React from 'react';
import PropTypes from 'prop-types';
import Abbr from '../../../shared/Abbr';

const HorseHeader = ({ isJockey }) => (
    <Abbr
        breakpoint="fromMedium"
        title={`Finishing dist / Horse ${isJockey ? '/ weight ' : ''}/ hdgr`}
    >
        <span className="hidden-xs-down">Finishing dist / </span>
        Horse
        {isJockey &&
        <span className="hidden-xs-down"> / weight</span>
        }
    </Abbr>
);

HorseHeader.propTypes = {
    isJockey: PropTypes.bool,
};

export default HorseHeader;



// WEBPACK FOOTER //
// ./src/js/human/form/components/HorseHeader.jsx